import { registerRoutes } from 'foremanReact/routes/RoutingService';
import routes from './Routes/routes';
import registerReducers from './react_app/extend/reducers';
import registerFills from './react_app/extend/Fills';

registerReducers();
registerRoutes('foreman_remote_execution', routes);
registerFills();



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/global_index.js